import React, { useEffect, useState } from "react";

export const LEADERBOARD_ROUNDS = [
	{
		id: "oct-week-1",
		label: "Week 1",
		start: "2026-10-08T12:00:00+08:00",

		// Exclusive end
		// Means leaderboard runs until Oct 15, 11:59:59 AM
		end: "2026-10-15T12:00:00+08:00",
		pushMessage: "2026-10-15T15:00:00+08:00",

		displayDate: "Oct 08 (12:00PM) - Oct 15 (11:59AM)",
	},
	{
		id: "oct-week-3",
		label: "Week 3",
		start: "2026-10-22T12:00:00+08:00",

		// Exclusive end
		// Means leaderboard runs until Oct 29, 11:59:59 AM
		end: "2026-10-29T12:00:00+08:00",
		pushMessage: "2026-10-29T15:00:00+08:00",

		displayDate: "Oct 22 (12:00PM) - Oct 29 (11:59AM)",
	},
];
export const getKeepPushingMessage = () => {
	const now = Date.now();

	const week1PushStart = new Date(LEADERBOARD_ROUNDS[0].pushMessage).getTime();

	const week3Start = new Date(LEADERBOARD_ROUNDS[1].start).getTime();

	const week3PushStart = new Date(LEADERBOARD_ROUNDS[1].pushMessage).getTime();

	// Oct Week 1 push message period
	if (now >= week1PushStart && now < week3Start) {
		return true;
	}

	// Oct Week 3 push message period
	if (now >= week3PushStart) {
		return true;
	}

	return false;
};

export const getKeepPushingRound = () => {
	const now = Date.now();

	const week1End = new Date(LEADERBOARD_ROUNDS[0].end).getTime();

	const week3Start = new Date(LEADERBOARD_ROUNDS[1].start).getTime();

	// Between Week 1 and Week 3
	if (now >= week1End && now < week3Start) {
		return {
			show: true,
			round: LEADERBOARD_ROUNDS[1],
		};
	}

	return {
		show: false,
		round: null,
	};
};

const getTimeLeft = (targetDate) => {
	const difference = new Date(targetDate).getTime() - Date.now();

	if (difference <= 0) {
		return {
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
			expired: true,
		};
	}

	return {
		days: Math.floor(difference / (1000 * 60 * 60 * 24)),

		hours: Math.floor((difference / (1000 * 60 * 60)) % 24),

		minutes: Math.floor((difference / (1000 * 60)) % 60),

		seconds: Math.floor((difference / 1000) % 60),

		expired: false,
	};
};

const formatNumber = (value) => String(value).padStart(2, "0");

export const getLeaderboardStatus = () => {
	const now = Date.now();

	const week1 = LEADERBOARD_ROUNDS[0];
	const week3 = LEADERBOARD_ROUNDS[1];

	const week1Start = new Date(week1.start).getTime();
	const week1End = new Date(week1.end).getTime();

	const week3Start = new Date(week3.start).getTime();
	const week3End = new Date(week3.end).getTime();

	// Before Week 1
	if (now < week1Start) {
		return {
			status: "upcoming",
			round: week1,
			targetDate: week1.start,
			visible: true,
		};
	}

	// WEEK 1
	if (now >= week1Start && now < week1End) {
		return {
			status: "active",
			round: week1,
			targetDate: week1.end,
			visible: true,
		};
	}

	// WEEK 2
	// Oct 8 12PM -> Oct 15 12PM
	if (now >= week1End && now < week3Start) {
		return {
			status: "hidden",
			round: null,
			targetDate: null,
			visible: false,
		};
	}

	// WEEK 3
	if (now >= week3Start && now < week3End) {
		return {
			status: "active",
			round: week3,
			targetDate: week3.end,
			visible: true,
		};
	}

	// WEEK 4 / after Week 3
	return {
		status: "hidden",
		round: null,
		targetDate: null,
		visible: false,
	};
};

export default function CountdownTimer({
	activeTitle = "Round Ends In:",
	upcomingTitle = "Leaderboard Starts In:",
	showTitle = true,
	showDate = true,
}) {
	const [statusData, setStatusData] = useState(getLeaderboardStatus);

	const [timeLeft, setTimeLeft] = useState(() => {
		const data = getLeaderboardStatus();
		return data.targetDate ? getTimeLeft(data.targetDate) : null;
	});

	useEffect(() => {
		const updateCountdown = () => {
			const data = getLeaderboardStatus();

			setStatusData(data);

			if (data.targetDate) {
				setTimeLeft(getTimeLeft(data.targetDate));
			} else {
				setTimeLeft(null);
			}
		};

		updateCountdown();

		const interval = setInterval(updateCountdown, 1000);

		return () => clearInterval(interval);
	}, []);

	// Hide completely during Week 2 and Week 4
	if (!statusData.visible) {
		return null;
	}

	const { round, status } = statusData;
	const isActive = status === "active";

	return (
		<div className="fortune-countdown">
			{showTitle && (
				<div className="fortune-countdown__label">
					{isActive ? activeTitle : upcomingTitle}
				</div>
			)}

			{timeLeft && (
				<div className="fortune-countdown__timer">
					<TimeBox value={timeLeft.days} label="DAYS" />

					<span className="fortune-countdown__separator">:</span>

					<TimeBox value={timeLeft.hours} label="HRS" />

					<span className="fortune-countdown__separator">:</span>

					<TimeBox value={timeLeft.minutes} label="MIN" />

					<span className="fortune-countdown__separator">:</span>

					<TimeBox value={timeLeft.seconds} label="SEC" />
				</div>
			)}
			{showDate && (
				<div className="fortune-countdown__date">{round.displayDate}</div>
			)}
		</div>
	);
}

function TimeBox({ value, label }) {
	return (
		<div className="fortune-countdown__unit">
			<div className="fortune-countdown__value">{formatNumber(value)}</div>

			<div className="fortune-countdown__unit-label">{label}</div>
		</div>
	);
}
